/* global gec:true*/
/* exported gec */
/* eslint-disable no-var */
/* eslint no-underscore-dangle: ["error", { "allow": ["_selections", "_base"] }] */
gec = (function (gec) {
    "use strict";

    var gecPrivate = gec.gecPrivate || {};
    var gecSeal = gec.gecSeal || function () {
        delete gec.gecPrivate;
        delete gec.gecSeal;
        delete gec.gecUnseal;
    };
    var gecUnseal = gec.gecUnseal || function () {
        gec.gecPrivate = gecPrivate;
        gec.gecSeal = gecSeal;
        gec.gecUnseal = gecUnseal;
    };

    gec.Controller.prototype.listSportsbookMarkets = function (params) {
        var request;
        if (gecPrivate.controllerDefaults === null && gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ "returnCode": 591 }));
        } else {
            request = new gec.IAPIRequest(params);

            request.sessionToken = gecPrivate.sessionToken;
            request.eventClassifierId = params.eventClassifierId;
            request.marketIds = params.marketIds;
            request.marketTypes = params.marketTypes;

            request.wantIndirectDescendents = params.wantIndirectDescendents;
            request.wantPricedMarketsOnly = params.wantPricedMarketsOnly;

            if (gecPrivate.userContext !== null) {
                request.integrationPartnerId = gecPrivate.userContext.integrationPartnerId;
                request.language = gecPrivate.userContext.language;
            } else { // use defaults
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.language = gecPrivate.controllerDefaults.language;
            }

            this.sendRequest("/listSportsbookMarkets.ashx", request, function (requestParam, response) {
                if (response.returnCode === 0) {

                    request.callbackOnSuccess({
                        markets: response.markets,
                        eventClassifiers: response.eventClassifiers
                    });
                } else {
                    request.callbackOnException(new gec.AsyncException(response));
                }

            });
        }
    };

    gec.Controller.prototype.getSportsbookPrices = function (params) {
        var request;
        if (gecPrivate.controllerDefaults === null && gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ "returnCode": 591 }));
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.eventClassifierId !== undefined) {
                request.eventClassifierId = params.eventClassifierId;
                request.marketType = params.marketTypeId;
            } else if (params.eventClassifier !== undefined) {
                request.eventClassifierId = params.eventClassifier.eventClassifierId;
                request.marketType = params.marketTypeId;
            } else if (params.markets !== undefined) {
                request.marketIds = []; // :Array;
                params.markets.forEach(function (market) {
                    request.marketIds.push(market.marketId);
                });
            } else {
                if (params.selectionIds !== undefined) {
                    request.selectionIds = params.selectionIds;
                } else {
                    request.marketIds = params.marketIds;
                }
            }
            request.justRefreshPrices = params.justRefreshPrices;
            request.wantIcons = params.wantIcons; // :Boolean;
            request.wantSelectionBlurb = params.wantSelectionBlurb; // :Boolean;

            request.organisationalUnitId = params.organisationalUnitId;
            if (gecPrivate.userContext !== null) {
                request.integrationPartnerId = gecPrivate.userContext.integrationPartnerId;
                request.currency = gecPrivate.userContext.currency; // :String;
                request.priceFormat = gecPrivate.userContext.priceFormat;
                request.language = gecPrivate.userContext.language;
            } else { // use defaults
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.currency = gecPrivate.controllerDefaults.currency; // :String;
                request.language = gecPrivate.controllerDefaults.language;
                request.priceFormat = gecPrivate.controllerDefaults.priceFormat;
            }

            request.contextEvents = params.contextEvents;

            this.sendRequest("/GetSportsBookPrices.ashx", request, function (requestParam, response) {
                var marketArrays = [];

                if (response.returnCode === 0) {
                    if (response.markets !== undefined) {
                        response.markets.sort(gec.SortOnDisplayOrder);
                        response.markets.forEach(function (responseMarket) {
                            var thisMarket = new gec.MarketDetail();
                            thisMarket.ancestryChain = responseMarket.ancestryChain || response.ancestryChain;
                            thisMarket.previousEventClassifier = response.previousEventClassifier;
                            thisMarket.nextEventClassifier = response.nextEventClassifier;

                            thisMarket.marketId = responseMarket.marketId;
                            thisMarket.eventClassifierFullName = responseMarket.eventClassifierFullName;
                            thisMarket.marketName = responseMarket.name;
                            thisMarket.marketType = responseMarket.marketType;
                            thisMarket.eventClassifierId = responseMarket.parentEventClassifierId;

                            thisMarket.willBeInRunning = responseMarket.canBeInRunning;
                            thisMarket.isCurrentlyInRunning = responseMarket.isCurrentlyInRunning;
                            thisMarket.isEnabledForMultipleBets = responseMarket.isMultiplesEnabled;
                            thisMarket.isEnabledForEachWayBetting = responseMarket.isEnabledForEachWayBetting;
                            thisMarket.isEnabledForSPBetting = responseMarket.isEnabledForSPBetting;
                            thisMarket.startTime = responseMarket.startTime;
                            thisMarket.suspendTime = responseMarket.suspendTime;
                            thisMarket.selectionIconsURL = responseMarket.selectionIconsURL;
                            thisMarket.iconWidth = responseMarket.iconWidth;
                            thisMarket.iconHeight = responseMarket.iconHeight;

                            thisMarket.placePayout = responseMarket.placePayout;

                            thisMarket.numberOfWinningSelections = responseMarket.numberOfWinningSelections;

                            thisMarket.marketStatusId = responseMarket.marketStatus;
                            thisMarket.withdrawalSequenceNumber = responseMarket.withdrawalSequenceNumber;

                            responseMarket.selections.sort(gec.SortOnDisplayOrder);


                            responseMarket.selections.forEach(function (thisSelection) {

                                var aSelection = new gec.SelectionDetail();
                                aSelection.selectionId = thisSelection.selectionId;
                                aSelection.selectionName = thisSelection.name;
                                aSelection.selectionIcon = thisSelection.icon;
                                aSelection.selectionIconIndex = thisSelection.selectionIconIndex;
                                aSelection.selectionBlurb = thisSelection.selectionBlurb;
                                aSelection.selectionStatusId = thisSelection.status;
                                aSelection.selectionResetCount = thisSelection.selectionResetCount;
                                aSelection.withdrawalFactor = thisSelection.withdrawalFactor;

                                aSelection.forSportsbookPrices = new gec.SportsbookPrice({
                                    price: thisSelection.currentForPrice,
                                    backReferencePrice: thisSelection.currentForDisplayPrice
                                });


                                if (thisSelection.currentForAmountAvailable !== undefined) {
                                    aSelection.forSportsbookPrices.amountAvailable = thisSelection.currentForAmountAvailable.amount;
                                }
                                aSelection.forSportsbookPrices.prices = [];
                                if (thisSelection.currentForPriceDetailedList !== undefined) {
                                    thisSelection.currentForPriceDetailedList.forEach(function (forPrice) {

                                        aSelection.forSportsbookPrices.prices.push({
                                            price: forPrice.price,
                                            stakeAvailable: forPrice.stake.amount
                                        });
                                    });
                                }

                                aSelection.forSportsbookPrices.stakes = [];
                                if (thisSelection.currentForPriceStakeList !== undefined) {
                                    thisSelection.currentForPriceStakeList.forEach(function (forStake) {
                                        aSelection.forSportsbookPrices.stakes.push(forStake.amount);
                                    });
                                }

                                aSelection.againstSportsbookPrices = new gec.SportsbookPrice({
                                    price: thisSelection.currentAgainstPrice
                                });

                                if (thisSelection.currentAgainstAmountAvailable !== undefined) {
                                    aSelection.againstSportsbookPrices.amountAvailable = thisSelection.currentAgainstAmountAvailable.amount;
                                }

                                aSelection.againstSportsbookPrices.prices = [];
                                if (thisSelection.currentAgainstPriceDetailedList !== undefined) {

                                    thisSelection.currentAgainstPriceDetailedList.forEach(function (againstPrice) {
                                        aSelection.againstSportsbookPrices.prices.push({
                                            price: againstPrice.price,
                                            stakeAvailable: againstPrice.stake.amount
                                        });
                                    });

                                }
                                aSelection.againstSportsbookPrices.stakes = [];
                                if (thisSelection.currentAgainstPriceStakeList !== undefined) {
                                    thisSelection.currentAgainstPriceStakeList.forEach(function (againstStake) {
                                        aSelection.againstSportsbookPrices.stakes.push(againstStake.amount);
                                    });
                                }

                                aSelection.market = thisMarket;
                                gecPrivate._selections[aSelection.selectionId] = aSelection;

                                thisMarket.selections.push(aSelection);
                            });

                            marketArrays.push(thisMarket);

                        });
                    }

                    request.callbackOnSuccess(marketArrays);
                } else {
                    request.callbackOnException(new gec.AsyncException(response));
                }

            });
        }
    };

    gec.Controller.prototype.getSportsbookMarketsBlurb = function (params) {
        var request;
        if (gecPrivate.controllerDefaults === null && gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ "returnCode": 591 }));
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.markets !== undefined) {
                request.eventClassifierId = null;
                request.marketIds = [];
                params.markets.forEach(function (market) {
                    request.marketIds.push(market.marketId);
                });

            } else {
                request.marketIds = undefined;
                request.eventClassifierId = params.eventClassifierId;
                request.marketType = params.marketTypeId;
            }

            if (gecPrivate.userContext !== null) {
                request.integrationPartnerId = gecPrivate.userContext.integrationPartnerId;
                request.language = gecPrivate.userContext.language;
            } else { // use defaults
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.language = gecPrivate.controllerDefaults.language;
            }
            this.sendRequest("/GetSportsBookMarketBlurb.ashx", request, function (ignore, response) {
                if (response.returnCode === 0) {
                    params.callbackOnSuccess(response.marketBlurbs);
                } else {
                    params.callbackOnException({ returnCode: response.returnCode });
                }

            });
        }
    };

    gec.Controller.prototype.placeBets = function (params) {
        var request;
        function stringify(obj) {
            let cache = [];
            const str = JSON.stringify(obj, function (key, value) {
                if (typeof value === "object" && value !== null) {
                    if (cache.indexOf(value) !== -1) {
                        return;
                    }
                    cache.push(value);
                }
                return value;
            });
            cache = null;
            return str;
        }

        if (gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ returnCode: 590, message: "NeitherUserNorTelebetUserSession " }));
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.channelInformation = params.channelInformation || "GBEIntegrationSolution";
            request.useFreeBet = params.useFreeBet;
            request.autoOddsAcceptanceOption = params.autoOddsAcceptanceOption;

            request.betRequests = [];
            params.requestedBets.forEach(function (bet) {
                var newBet;
                bet.selectionId = Number(bet.selection.selectionId);
                bet.amountRequested = {
                    amount: bet.amountRequested,
                    currency: gecPrivate.userContext.currency
                };
                if (bet.fillOrKillThreshold === undefined) {
                    bet.fillOrKillThreshold = bet.amountRequested;
                }
                newBet = JSON.parse(stringify(bet));
                newBet.counterOfferId = bet.counterOfferId;

                delete newBet.selection;

                request.betRequests.push(newBet);
            });
            this.sendRequest("/PlaceBets.ashx", request, function (requestParam, response) {
                var i = 0;
                var bets = [];
                var lastBet;
                if (response.returnCode === 0) {
                    response.betResponses.forEach(function (betResponse) {

                        if (betResponse.returnCode === 0) {
                            betResponse.polarity = params.requestedBets[i].polarity;
                            betResponse.selectionId = params.requestedBets[i].selectionId;
                            betResponse.selectionName = params.requestedBets[i].selection.name || params.requestedBets[i].selection.selectionName;
                            betResponse.marketName = params.requestedBets[i].selection.getMarket().marketName;
                            betResponse.eventClassifierFullName = params.requestedBets[i].selection.getMarket().eventClassifierFullName;
                            betResponse.withdrawalSequenceNumber = params.requestedBets[i].expectedWithdrawalSequenceNumber;
                            betResponse.punterGrossAmountRequested = params.requestedBets[i].amountRequested.amount;
                            betResponse.punterPrice = betResponse.punterPrice || params.requestedBets[i].punterPriceRequested;
                            betResponse.marketId = params.requestedBets[i].selection.getMarket().marketId;
                            betResponse.sportsBetPriceType = params.requestedBets[i].sportsBetPriceType;

                            bets.push(new gec.Bet(betResponse));
                        } else {

                            lastBet = { returnCode: betResponse.returnCode };

                            if (betResponse.availableStake !== undefined) {
                                lastBet.availableStake = betResponse.availableStake;
                            }

                            if (betResponse.returnCode === 454 && betResponse.counterOfferId) {
                                lastBet.counterOfferId = betResponse.counterOfferId;
                                lastBet.counterOfferStake = betResponse.counterOfferStake.amount;
                                lastBet.counterOfferPrice = betResponse.counterOfferPrice;
                                lastBet.counterOfferValidUntil = betResponse.counterOfferValidUntil;
                            }
                            bets.push(lastBet);
                        }

                        i = i + 1;
                    });
                    request.callbackOnSuccess(bets);
                } else {
                    request.callbackOnException(new gec.AsyncException({ returnCode: response.returnCode }));
                }

            });
        }
    };

    gec.Controller.prototype.listCurrentBets = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ returnCode: 590, message: "NeitherUserNorTelebetUserSession " }));
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;

            if (params.marketIds === undefined) {
                params.marketIds = [];
            }

            request.marketId = params.marketId;
            request.marketsId = params.marketIds;
            if (params.includeCashOutHistory) {
                request.includeCashOutHistory = params.includeCashOutHistory;
            }
            this.sendRequest("/ListCurrentBets.ashx", request, function (requestParam, response) {
                var betArray = [];
                if (response.returnCode !== 0) {
                    request.callbackOnException({ returnCode: response.returnCode });
                } else {
                    if (response.localBets !== null) {
                        response.localBets.forEach(function (localBet) {
                            betArray.push(new gec.Bet(localBet));
                        });

                    }
                    request.callbackOnSuccess(betArray);
                }
            });
        }
    };

    gec.Controller.prototype.requestCashOutOffer = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, "message": "NeitherUserNorTelebetUserSession" });
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.localBetIds = params.localBetId;

            this.sendRequest("/RequestCashOutOffer.ashx", request, function (requestParam, response) {
                var returnObject = {};
                if (response.returnCode !== 0) {
                    params.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    if (response.cashoutOffers) {
                        returnObject.cashoutOffers = response.cashoutOffers;
                    }
                    if (response.totalCashOutOffer) {
                        returnObject.totalCashOutOffer = response.totalCashOutOffer;
                    }
                    if (response.totalEquityAmount) {
                        returnObject.totalEquityAmount = response.totalEquityAmount;
                    }
                    params.callbackOnSuccess(returnObject);
                }
            });
        }
    };

    gec.Controller.prototype.cashOutBets = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException({ "returnCode": 590, message: "NeitherUserNorTelebetUserSession" });
        } else {
            request = new gec.IAPIRequest(params);
            request.sessionToken = gecPrivate.sessionToken;
            request.wantAllOrNothing = params.wantAllOrNothing;
            request.firstRequestedAt = params.firstRequestedAt;
            request.bets = params.localBets;
            this.sendRequest("/CashOutBets.ashx", request, function (requestParam, response) {
                if (response.returnCode !== 0) {
                    request.callbackOnException({ "returnCode": response.returnCode });
                } else {
                    request.callbackOnSuccess(response);
                }
            });
        }
    };

    gec.Controller.prototype.getBetDetails = function (params) {
        var request = new gec.IAPIRequest(params);
        request.sessionToken = gecPrivate.sessionToken;
        request.localBetId = params.localBetId;
        request.includeCashOutHistory = params.includeCashOutHistory;

        this.sendRequest("/GetBetDetails.ashx", request, function (requestParam, response) {
            if (response.returnCode !== 0) {
                request.callbackOnException({ returnCode: response.returnCode });
            } else {
                request.callbackOnSuccess(new gec.Bet(response));
            }
        });
    };
    gec.Controller.prototype.getBet = function (params) {
        window.console.warn("getBet obsolete - use getBetDetails");
        return this.getBetDetails(params);
    };

    gec.Controller.prototype.getSportsbookPricesEnhanced = function (params) {
        var request;
        if (gecPrivate.controllerDefaults === null && gecPrivate.userContext === null) {
            params.callbackOnException({
                returnCode: 591
            });
        } else {
            request = new gec.IAPIRequest(params);
            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;

            if (gecPrivate.userContext !== null) {
                request.sessionToken = gecPrivate.sessionToken;
            } else { // use defaults
                request.language = gecPrivate.controllerDefaults.language;
                request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
                request.currency = gecPrivate.controllerDefaults.currency;
                request.priceFormat = gecPrivate.controllerDefaults.priceFormatId;
            }
            request.organisationalUnitId = 0;
            request.marketId = params.marketId;
            request.thresholdAmount = {
                amount: params.thresholdAmount,
                currency: request.currency
            };

            request.numberForPricesRequired = params.numberForPricesRequired;
            request.numberAgainstPricesRequired = params.numberAgainstPricesRequired;
            request.wantIcons = params.wantIcons;
            request.wantMultiplesOnly = params.wantMultiplesOnly;

            this.sendRequest("/GetSportsbookPricesEnhanced.ashx", request, function (requestParam, response) {
                var marketDetail;
                if (response.returnCode !== 0) {
                    gecPrivate.checkExpiredSession(response.returnCode);
                    request.callbackOnException({
                        returnCode: response.returnCode
                    });
                } else {

                    marketDetail = new gec.MarketDetail();

                    marketDetail.marketId = response.marketId;
                    marketDetail.eventClassifierId = response.parentEventClassifierId;
                    marketDetail.eventClassifierFullName = response.eventClassifierFullName;
                    marketDetail.marketName = response.name;
                    marketDetail.isEnabledForMultipleBets = response.isEnabledForMultiples;
                    if (response.selectionIconsURL !== undefined) {
                        marketDetail.selectionIconsURL = response.selectionIconsURL;
                        marketDetail.iconWidth = response.iconWidth;
                        marketDetail.iconHeight = response.iconHeight;
                    }
                    marketDetail.marketType = response.marketType;
                    marketDetail.placePayout = response.placePayout;
                    marketDetail.willBeInRunning = response.isInRunningAllowed;
                    marketDetail.managedWhenInRunning = response.managedWhenInRunning;
                    marketDetail.inRunningDelaySeconds = response.inRunningDelaySeconds;
                    if (response.totalMatchedAmount !== undefined) {
                        marketDetail.totalMatchedAmount = response.totalMatchedAmount.amount;
                    }
                    marketDetail.isCurrentlyInRunning = response.isCurrentlyInRunning;
                    marketDetail.numberOfWinningSelections = response.numberOfWinningSelections;
                    marketDetail.startTime = response.startTime;
                    marketDetail.suspendTime = response.suspendTime;
                    marketDetail.marketStatusId = response.marketStatus;
                    marketDetail.withdrawalSequenceNumber = response.withdrawalSequenceNumber;
                    marketDetail.isEnabledForEachWayBetting = response.isEnabledForEachWayBetting;
                    marketDetail.isEnabledForSPBetting = response.isEnabledForSPBetting;

                    marketDetail.selections.sort(gec.SortOnDisplayOrder);

                    response.selections.forEach(function (thisSelection) {

                        var aSelection = new gec.SelectionDetail({
                            selectionId: thisSelection.selectionId,
                            selectionName: thisSelection.name,
                            selectionBlurb: thisSelection.selectionBlurb,
                            selectionIconIndex: thisSelection.selectionIconIndex,
                            selectionStatusId: thisSelection.status,
                            selectionResetCount: thisSelection.selectionResetCount,
                            currentForPrice: thisSelection.currentForPrice,
                            currentAgainstPrice: thisSelection.currentAgainstPrice,
                            withdrawalFactor: response.withdrawalSequenceNumber
                        });

                        if (thisSelection.currentForPrice > 0) {
                            aSelection.forExchangePrices = [];
                            thisSelection.currentForPriceStakesDetailed.forEach(function (forPrice) {
                                aSelection.forExchangePrices.push(new gec.ExchangePrice({
                                    price: forPrice.price,
                                    displayPrice: forPrice.displayPrice,
                                    amountAvailable: gecPrivate._base.formatDecimal(forPrice.stakeAvailable.amount, 0, ""),
                                    hasRecentlyChanged: true
                                }));

                            });
                        }

                        if (thisSelection.currentAgainstPrice > 0) {
                            thisSelection.currentAgainstPriceStakesDetailed.forEach(function (againstPrice) {
                                aSelection.againstExchangePrices.push(new gec.ExchangePrice({
                                    price: againstPrice.price,
                                    displayPrice: againstPrice.displayPrice,
                                    amountAvailable: gecPrivate._base.formatDecimal(againstPrice.stakeAvailable.amount, 0, ""),
                                    hasRecentlyChanged: true
                                }));

                            });
                        }

                        aSelection.market = marketDetail;

                        marketDetail.selections.push(aSelection);
                    });

                    request.callbackOnSuccess({
                        marketDetail: marketDetail,
                        topLevelEventClassifierId: response.topLevelEventClassifierId,
                        grandparentEventClassifierId: response.grandparentEventClassifierId,
                        relatedEventClassifiers: response.relatedEventClassifiers,
                        relatedMarkets: response.relatedMarkets
                    });

                }
            });
        }
    };

    gec.Controller.prototype.requestSBMultipleBetQuotation = function (params) {
        var request;
        request = new gec.IAPIRequest(params);
        request.callbackOnException = params.callbackOnException;
        request.callbackOnSuccess = params.callbackOnSuccess;
        request.sessionToken = gecPrivate.sessionToken;

        request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
        request.currency = gecPrivate.controllerDefaults.currency; // :String;
        request.language = gecPrivate.controllerDefaults.language;

        request.selections = params.selections;
        request.combinationTypes = params.combinationTypes;
        request.riskGroupProfileName = params.riskGroupProfileName;

        this.sendRequest("/requestSBMultipleBetQuotation.ashx", request, function (requestParam, response) {

            if (response.returnCode !== 0) {
                gecPrivate.checkExpiredSession(response.returnCode);
                request.callbackOnException(response);
            } else {

                delete response.returnCode;

                request.callbackOnSuccess(response);

            }
        });
    };

    gec.Controller.prototype.requestSBMultipleCustomBetQuotation = function (params) {
        var request;
        request = new gec.IAPIRequest(params);
        request.callbackOnException = params.callbackOnException;
        request.callbackOnSuccess = params.callbackOnSuccess;
        request.sessionToken = gecPrivate.sessionToken;

        request.integrationPartnerId = gecPrivate.controllerDefaults.integrationPartnerId;
        request.currency = gecPrivate.controllerDefaults.currency; // :String;
        request.language = gecPrivate.controllerDefaults.language;

        request.selections = params.selections;
        request.combinationTypes = params.combinationTypes;
        request.customSBMultipleBetType = params.customSBMultipleBetType;

        this.sendRequest("/requestSBMultipleCustomBetQuotation.ashx", request, function (requestParam, response) {

            if (response.returnCode !== 0) {
                gecPrivate.checkExpiredSession(response.returnCode);
                request.callbackOnException(response);
            } else {

                delete response.returnCode;

                request.callbackOnSuccess(response);

            }
        });
    };

    gec.Controller.prototype.placeSBMultipleBet = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ returnCode: 590, message: "NeitherUserNorTelebetUserSession " }));
        } else {

            request = new gec.IAPIRequest(params);
            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;
            request.sessionToken = gecPrivate.sessionToken;
            request.acceptPriceChange = params.acceptPriceChange;
            request.punterId = gecPrivate.userContext.punterId;
            request.channelType = params.channelType;
            request.channelInformation = params.channelInformation;
            request.accaGroupName = params.accaGroupName;
            request.customBetType = params.customBetType;

            request.participants = params.participants;
            if (params.counterOfferId) {
                request.counterOfferId = params.counterOfferId;
            }
            request.combinationTypes = params.combinationTypes;
            if (params.punterReferenceNumber) {
                request.punterReferenceNumber = params.punterReferenceNumber;
            }
            request.useFreeBet = params.useFreeBet;

            this.sendRequest("/placeSBMultipleBet.ashx", request, function (requestParam, response) {

                if (response.returnCode !== 0) {
                    gecPrivate.checkExpiredSession(response.returnCode);
                    request.callbackOnException(response);
                } else {

                    delete response.returnCode;

                    request.callbackOnSuccess(response);

                }
            });
        }
    };

    gec.Controller.prototype.requestSBMultipleBetCashOut = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ returnCode: 590, message: "NeitherUserNorTelebetUserSession " }));
        } else {

            request = new gec.IAPIRequest(params);
            request.multipleBetId = params.multipleBetId;

            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;
            request.sessionToken = gecPrivate.sessionToken;

            this.sendRequest("/requestSBMultipleBetCashOut.ashx", request, function (requestParam, response) {

                if (response.returnCode !== 0) {
                    gecPrivate.checkExpiredSession(response.returnCode);
                    request.callbackOnException(response);
                } else {

                    delete response.returnCode;

                    request.callbackOnSuccess(response);

                }
            });
        }
    };

    gec.Controller.prototype.cashOutSBMultipleBet = function (params) {
        var request;
        if (gecPrivate.userContext === null) {
            params.callbackOnException(new gec.AsyncException({ returnCode: 590, message: "NeitherUserNorTelebetUserSession " }));
        } else {

            request = new gec.IAPIRequest(params);

            request.multipleBetId = params.multipleBetId;
            request.cashOutOffer = {
                amount: params.cashOutOffer,
                currency: gecPrivate.controllerDefaults.currency
            };
            request.cashOutEquityPercentage = params.cashOutEquityPercentage;

            request.callbackOnException = params.callbackOnException;
            request.callbackOnSuccess = params.callbackOnSuccess;
            request.sessionToken = gecPrivate.sessionToken;

            this.sendRequest("/cashOutSBMultipleBet.ashx", request, function (requestParam, response) {

                if (response.returnCode !== 0) {
                    gecPrivate.checkExpiredSession(response.returnCode);
                    request.callbackOnException(response);
                } else {

                    delete response.returnCode;

                    request.callbackOnSuccess(response);

                }
            });
        }
    };

    gec.Bet = function (params) {
        // Properties
        var histories;

        this.localBetId = params.localBetId;
        this.placedAt = params.placedAt;
        this.withdrawalSequenceNumber = params.withdrawalSequenceNumber;
        this.punterGrossAmountRequested = params.punterGrossAmountRequested;
        this.punterPrice = params.punterPrice;
        this.isEachWay = params.isEachWay;
        this.adjustedStrikePrice = params.adjustedStrikePrice;

        this.punterNetAmountPlaced = params.punterNetAmountPlaced !== undefined ? params.punterNetAmountPlaced.amount : undefined;
        this.punterGrossAmountPlaced = params.punterGrossAmountPlaced !== undefined ? params.punterGrossAmountPlaced.amount : undefined;
        this.polarityId = params.polarity ? 1 : 2; // deprecated
        this.polarity = params.polarity ? 1 : 2;
        this.isFreeBet = params.isFreeBet;
        this.betStatusId = params.betStatus !== undefined ? params.betStatus : 1; // deprecated
        this.betStatus = params.betStatus !== undefined ? params.betStatus : 1;

        this.placePayout = params !== undefined ? params.placePayout : null;
        this.settledAt = params !== undefined ? params.settledAt : null;
        this.punterPriceWhenSettled = params !== undefined ? params.punterPriceWhenSettled : null;

        this.sportsBetPriceType = params.sportsBetPriceType;
        this.startTime = params.startTime;

        if (params.adjustedStrikePrice !== undefined) {
            this.adjustedStrikePrice = params.adjustedStrikePrice;
        }

        if (params.settledAt !== undefined) {

            this.settledAt = params.settledAt;
            this.netSettlementAmount = params.netSettlementAmount.amount;
            this.punterPriceWhenSettled = params.punterPriceWhenSettled;
        }

        if (params.cashOutHistory !== undefined) {
            histories = [];

            params.cashOutHistory.forEach(function (cashOutHistory) {
                var history = {
                    cashOutDatetime: cashOutHistory.cashOutDatetime,
                    cashOutReturnCode: cashOutHistory.cashOutReturnCode,
                    requestedCashOutAmount: cashOutHistory.requestedCashOutAmount
                };

                if (cashOutHistory.fixedPremium !== undefined) {
                    history.fixedPremium = cashOutHistory.fixedPremium;
                }

                if (cashOutHistory.betValuationWithConcession !== undefined) {
                    history.betValuationWithConcession = cashOutHistory.betValuationWithConcession;
                }

                if (cashOutHistory.cashOutOffer !== undefined) {
                    history.cashOutOffer = cashOutHistory.cashOutOffer.amount;
                }

                if (cashOutHistory.cashOutAmount !== undefined) {
                    history.cashOutAmount = cashOutHistory.cashOutAmount.amount;
                }

                if (cashOutHistory.cashOutStake !== undefined) {
                    history.cashOutStake = cashOutHistory.cashOutStake.amount;
                }

                if (cashOutHistory.totalCashOutAmount !== undefined) {
                    history.totalCashOutAmount = cashOutHistory.totalCashOutAmount.amount;
                }

                if (cashOutHistory.totalCashOutStake !== undefined) {
                    history.totalCashOutStake = cashOutHistory.totalCashOutStake.amount;
                }

                if (cashOutHistory.remainingStake !== undefined) {
                    history.remainingStake = cashOutHistory.remainingStake.amount;
                }

                if (cashOutHistory.betValuationWithConcession !== undefined) {
                    history.betValuationWithConcession = cashOutHistory.betValuationWithConcession.amount;
                }

                histories.push(history);
            });
            this.cashOutHistories = histories;

        }

        // Methods

        this.marketId = function () {
            return params.marketId;
        };
        this.marketName = function () {
            return params.marketName;
        };
        this.marketStatus = function () {
            return params.marketStatus;
        };
        this.selectionId = function () {
            return params.selectionId;
        };
        this.selectionName = function () {
            return params.selectionName;
        };
        this.eventClassifierId = function () {
            return params.eventClassifierId;
        };
        this.marketTypeId = function () {
            return params.marketType;
        };

        if (params.eventClassifierFullName !== undefined) {
            this.eventClassifierFullName = function () {
                return params.eventClassifierFullName;
            };
        } else {
            this.eventClassifierFullName = function () {
                return params.eventClassifierName;
            };
        }

    };

    gec.Bet.prototype.marketStatusId = function () {
        return this.marketStatusId;
    };
    gec.Bet.prototype.selectionId = function () {
        return this.selectionId;
    };
    gec.Bet.prototype.selectionName = function () {
        return this.selectionName;
    };

    gec.SportsbookPrice = function (params) {
        this.price = params.price;
        this.amountAvailable = params.amountAvailable;
        this.backReferencePrice = params.backReferencePrice;
        this.stakes = []; // Array[stake: MoneyAmount]
        this.prices = []; // Array[{price: Price, stakeAvailable: MoneyAmount}]
    };


    gec.SportsBetPriceType = {
        FixedPrice: 1,
        StartingPrice: 2,
        BestOddsGuaranteed: 3
    };

    return gec;

}(gec || {}));

// gec.gecSeal(); // prevent access to private props
